import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import 'LIBS/jquery.showhtml.js';
import 'HSNDIR/Template/EmailCaptureCommon.js';

/**
* class HSN.PrivateSaleEmailCaptureModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.PrivateSaleEmailCaptureModal = (function (parent) {
    __extends(PrivateSaleEmailCaptureModal, parent);

    function PrivateSaleEmailCaptureModal(config) {
        var modal = PrivateSaleEmailCaptureModal.__super__.constructor.call(this);

        this.Close.off();//remove existing handler, have our own

        this.name = 'HSN.private-sale-email-capture'

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Content).on('keyup', '#capture-email-address', function () {
            var $this = $(this);
            if (!HSN.ValidateEmail($('#capture-email-address').val())) {
                $this.addClass('invalid-email');
            } 
            else {
                $this.removeClass('invalid-email');
            }
            return;
        });

        $(modal.Content).on('click', '#capture-signup', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var emailAddress = $('#capture-email-address').val();
            var promoId = $(this).data('promoId');

            if(emailAddress === '' || emailAddress === null || !HSN.ValidateEmail(emailAddress)) {
                $('#capture-error').html('Please enter an email address.');
                $('#capture-email-address').addClass('invalid-email');
                return;
            }           

            HSN.DataLayer.helpers.metricEvent(null, 'RE:emailsignup', 'privatesale', 'SO');

            var config = {};
            config.success = function (data) {
                if (data.success) {
                    $.ajax('/stores-actions/private-sale/associate-promotion', {
                        dataType: 'json',
                        method: 'POST',
                        data: {promotionId: promoId},
                        success: function(responseData) {
                            window.location.reload();
                        }
                    }); 
                }

                return;
            };
            config.error = function () {
                alert('We\'re sorry, there was a problem saving your email address. Please try again later.');
            }

            HSN.Instance().HandleEmailSignup(emailAddress, 96, config);
        });

        $(modal.Content).on('click', '#capture-cancel', function (e) {
            e.stopPropagation();
            e.preventDefault();

            closeModal(modal);
        });

        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
    }

    function closeModal(modal) {             
        modal.Hide();
    }

    /**
    * HSN.PrivateSaleEmailCaptureModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    PrivateSaleEmailCaptureModal.prototype._show = function (promoId) {
        $.ajax('/stores-actions/private-sale/email-capture' + '?promoId=' + promoId + '&' + new Date().getTime(),
            {
                context: this,
                dataType: 'html',
                success: function (data, status, xhr) {
                    var __scope = this;
                    __scope.Root.removeClass('loading');

                    this.Content.showHtml(data,
                        0,
                        function () {
                            var elemetToFocus = __scope.Root.find('#modalPopup');  
                            __scope.Center();
                            __scope.Content.animate({ opacity: 1 }, function() {
                                __scope.SetFocus(elemetToFocus);
                            });

                            //handle any tooltips loaded
                            if (!Modernizr.touchevents) {
                                HSN.Tooltip(__scope.Content.find('[data-tooltip]'));
                            }                          
                        }
                    );

                    var inputWidget = new HSN.Widget.FancyInput();
                    inputWidget.init({
                        application: HSN.Instance(),
                        containerName: '.private-sale-email-capture'
                    });
                },
                error: function (xhr, status, error) {
                    //Dont think we want to display the loading error if this modal doesnt display?
                    //alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );
    };

    return PrivateSaleEmailCaptureModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/PrivateSaleEmailCaptureModal.js